import type { SVGProps } from "react";
export interface MessageStarIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function MessageStarIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: MessageStarIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M20.875 6c0-1.036-.84-1.875-1.875-1.875H5c-1.036 0-1.875.84-1.875 1.875v10c0 1.036.84 1.875 1.875 1.875h2c.62 0 1.125.504 1.125 1.125v1.77l3.534-2.25a4.13 4.13 0 0 1 2.215-.645H19c1.035 0 1.874-.84 1.875-1.875zm2.25 10A4.125 4.125 0 0 1 19 20.125h-5.126c-.268 0-.531.056-.773.166l-.233.128L9.14 22.79c-1.414.9-3.266-.115-3.266-1.791v-.873H5A4.125 4.125 0 0 1 .875 16V6A4.125 4.125 0 0 1 5 1.875h14A4.125 4.125 0 0 1 23.125 6z"
      />
      <path
        fill={color}
        d="M10.878 6.454a1.376 1.376 0 0 1 2.243 0l.106.177.838 1.667 1.882.27.199.043c.961.284 1.349 1.538.557 2.297l-1.35 1.292.318 1.823c.202 1.158-1.016 1.948-1.983 1.448l-1.689-.871-1.686.871c-.968.5-2.185-.29-1.983-1.448l.316-1.823-1.35-1.292c-.844-.81-.346-2.183.757-2.34l1.882-.27.838-1.667zm.803 3.38c-.165.33-.48.558-.845.61l-.672.095.473.453c.27.259.393.636.33 1.005l-.116.663.632-.326.125-.056c.295-.11.625-.09.908.056l.633.326-.116-.663c-.064-.37.06-.746.331-1.005l.472-.453-.671-.095a1.13 1.13 0 0 1-.847-.61L12 9.2l-.318.634Z"
      />
    </svg>
  );
}
